import { Avatar, type AvatarProps } from '@/components/play'
import { personToneKey } from '@/lib/profile'
import type { PublicProfile } from '@/lib/watch/types'

export type HostAvatarProps = Omit<AvatarProps, 'name' | 'src' | 'tone' | 'toneKey'> & { host: PublicProfile }

/**
 * The stage host's avatar, the same wherever it appears (the phone header, the chat's head, Back to host, the host's
 * pick on the canvas and the strip). An organisation without a logo is the brand's solid yellow, as the prototype's
 * organisation disc: the host set apart from the pastel people around it (sign-in is the site header's, so no yellow
 * button sits beside it any more). Its logo, once shown, sits on Play's neutral disc. A person has their photo, or their
 * tone, keyed as their chat messages, face and account are (`personToneKey`: their username, as the stage payload
 * carries no user id for its host).
 */
export function HostAvatar({ host, ...props }: HostAvatarProps) {
  const tone: Pick<AvatarProps, 'tone' | 'toneKey'> =
    host.kind === 'person' ? { tone: 'auto', toneKey: personToneKey({ handle: host.handle }) } : { tone: 'organization' }
  return <Avatar name={host.name} src={host.avatar_url} {...tone} {...props} />
}
